<template>
  <div>
    <schedule-visit :visible="showScheduleVisitForm" showButtons="false" buttonValue="verder"></schedule-visit>
    <phone-details :visible="showPhoneDetailsForm" buttonValue="verder"></phone-details>
  </div>
</template>
<script>
import {questionCookieService, SURVEY_TYPE_PLANNER} from "@/services/question";
import ScheduleVisit from "@/components/address-details/ScheduleVisit";
import PhoneDetails from "@/components/address-details/PhoneDetails";
import {mapGetters} from "vuex";

export default {
  name: "planner-view",
  components: {
    ScheduleVisit,
    PhoneDetails
  },
  data: () => ({
    showScheduleVisitForm: false,
    showPhoneDetailsForm: false
  }),
  computed: {
    ...mapGetters(["activeAddress"])
  },
  methods: {
    openScheduleVisitForm() {
      this.showScheduleVisitForm = true;
    },
    closeScheduleVisitForm() {
      this.showScheduleVisitForm = false;
      this.showPhoneDetailsForm = true;
    },
    closePhoneDetailsForm() {
      this.showPhoneDetailsForm = false;

      let payload = {
        "surveyType": SURVEY_TYPE_PLANNER,
        "recordId": this.activeAddress.uniqueIdAddress
      };
      questionCookieService.resolveCookie(payload)
          // eslint-disable-next-line no-unused-vars
          .then(_ => {
            this.$router.push("/questions");
          });
    }
  },
  created() {
    this.showScheduleVisitForm = true;
  }
};
</script>
